/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 15:09:29
 * @LastEditors: Liu ShuaiBo
 * @LastEditTime: 2021-10-26 15:09:29
 */
import ColumnTypes from '@/utils/ColumnTypes';
const time = {
	key: 'time',
	label: '创建时间',
	isNoShow: true,
	type: ColumnTypes.TextCell,
	isSearch: true,
	module: 'date',
};
const id = {
	key: 'id',
	label: '商品组ID',
	type: ColumnTypes.TextCell,
	isSearch: true,
	module: 'input',
};
const group_name = {
	key: 'group_name',
	label: '商品组名称',
	type: ColumnTypes.TextCell,
	isSearch: true,
	module: 'input',
};
const product_num = {
	key: 'product_num',
	label: '商品数量',
	type: ColumnTypes.TextCell,
};
const group_status_name = {
	key: 'group_status_name',
	label: '商品组状态',
	type: ColumnTypes.promoteStateCell,
	isSearch: true,
	module: 'select',
	minWidth: '100',
	selectList: [
		{
			label: '关闭推广',
			value: 0,
		},
		{
			label: '推广中',
			value: 1,
		},
	],
};
const partner_role_name = {
	key: 'partner_name',
	label: '创建人',
	type: ColumnTypes.TextCell,
	isSearch: true,
	module: 'input',
};
const remark = {
	key: 'remark',
	label: '备注',
	type: ColumnTypes.TextCell,
};

const operations = {
	key: 'operations',
	label: '操作',
	type: ColumnTypes.ButtonsCell,
	align: 'right',
	mode: 'vertical',
	width: '240',
};

export const columns = [id, group_name, time, product_num, group_status_name, partner_role_name, remark, operations];
